import { useState, useEffect } from "react";

/**
 * Retains the last non-null value passed in.
 */
export function useRetained(value) {
  const [retained, setRetained] = useState(value);

  useEffect(() => {
    if (value != null) {
      setRetained(value);
    }
  }, [value]);

  return retained;
}
